import { css } from "styled-components";

// https://csswizardry.com/2013/04/shame-css/
export const shameCSS = css``;
